module.exports = __webpack_public_path__ + "media/images/ico-stop-046af695.svg";